<template>
  <main
    v-loading.fullscreen.lock="fullScreenLoading"
    class="receipt-page"
  >
    <section
      v-if="!fullScreenLoading && !paymentFailed"
      :style="{
        '--primary-color': primaryColor,
      }"
    >
      <div>
        <receipt-header :primary-color="primaryColor" />
        <div class="body">
          <receipt-presentation v-if="isPresentationMode" />

          <div class="body-buttons">
            <div class="body-buttons-wrapper">
              <receipt-rating v-if="oneReviewButtonIsEnabled" />
              <receipt-review
                :transaction-info="transactionInfo"
                :qr-code="qrCode"
              />

              <div class="mb-10 mt-30">
                <router-link
                  v-if="groupQrCode > 0 && !teamMode"
                  :to="{
                    name: 'SelectEmployee',
                    params: {
                      qrCode: groupQrCode,
                      currency: transactionInfo.payment.currency,
                    },
                  }"
                  custom
                  v-slot="{ navigate }"
                >
                  <el-button
                    type="primary"
                    class="primary-button"
                    @click="navigate"
                    :style="{ background: primaryColor }"
                  >
                    {{
                      qrCode && qrCode.businessEntity.presentationMode
                        ? $t("receipt.more-tips-presentation")
                        : $t("receipt.more-tips")
                    }}
                  </el-button>
                </router-link>
                <router-link
                  v-else-if="groupQrCode > 0 && teamMode"
                  :to="{
                    name: 'SelectTeamPay',
                    params: {
                      groupQrCode: qrCode.businessEntity.groupQrCode,
                      currency: transactionInfo.payment.currency,
                    },
                  }"
                  custom
                  v-slot="{ navigate }"
                >
                  <el-button
                    type="primary"
                    class="primary-button"
                    @click="navigate"
                    :style="{ background: primaryColor }"
                  >
                    {{
                      qrCode && qrCode.businessEntity.presentationMode
                        ? $t("receipt.more-tips-presentation")
                        : $t("receipt.more-tips")
                    }}
                  </el-button>
                </router-link>
                <router-link
                  v-else
                  :to="{
                    name: 'Pay',
                    params: {
                      qrCode: transactionInfo.payment.qrCode,
                      currency: transactionInfo.payment.currency,
                    },
                  }"
                  custom
                  v-slot="{ navigate }"
                >
                  <el-button
                    type="primary"
                    class="primary-button"
                    @click="navigate"
                    :style="{ background: primaryColor }"
                  >
                    {{
                      qrCode && qrCode.businessEntity.presentationMode
                        ? $t("receipt.more-tips-presentation")
                        : $t("receipt.more-tips")
                    }}
                  </el-button>
                </router-link>
              </div>
            </div>
          </div>

          <receipt-tippie-feedback :show-warning="showRedirectWarning" />

          <receipt-transaction-details
            :payment-info="transactionInfo.payment"
          />
        </div>
      </div>
    </section>
    <PaymentFailed
      v-if="!fullScreenLoading && paymentFailed"
      :transaction-info="transactionInfo"
    />
  </main>
</template>

<script>
/* eslint-disable */
import reviewsMixin from "./reviews-mixin";
import ReceiptHeader from "./ReceiptHeader.vue";
import ReceiptPresentation from "./ReceiptPresentation.vue";
import ReceiptTransactionDetails from "./ReceiptTransactionDetails.vue";
import ReceiptReview from "./ReceiptReview/ReceiptReview.vue";
import ReceiptTippieFeedback from "./ReceiptTippieFeedback.vue";
import ReceiptRating from "./ReceiptRating.vue";
import PaymentFailed from "./PaymentFailed.vue";

export default {
  name: "Receipt",
  mixins: [reviewsMixin],
  data: () => ({
    paymentFailed: false,
    teamMode: false,
    fullScreenLoading: true,
    transactionInfo: {
      payment: {},
      schemaPrimaryColor: "#FF8A00",
      // feedbackEnabled: true,
    },
    groupQrCode: 0,
    qrCode: null,
  }),
  components: {
    ReceiptHeader,
    ReceiptTransactionDetails,
    ReceiptPresentation,
    ReceiptReview,
    ReceiptRating,
    ReceiptTippieFeedback,
    PaymentFailed
  },
  computed: {
    showRedirectWarning() {
      return (
        this.qrCode?.businessEntity?.id ===
          "6ed2cedc-1789-4153-9d8b-dfbc9e8b7b14" &&
        this.$cookie.get("query-string")
      );
    },
    isPresentationMode() {
      return this.qrCode && this.qrCode?.businessEntity.presentationMode;
    },
    primaryColor: function() {
      return this.transactionInfo.schemaPrimaryColor || "#FF8A00";
    },
  },
  async created() {
    this.txId = this.$route.params.transactionId || this.$cookie.get("txId");
    
    if (!this.txId) {
      this.fullScreenLoading = false;
      this.paymentFailed = true;
      return;
    }

    this.$axios
    .get(`/api/v1/tx/${this.txId}`)
      .then(async (response) => {
        this.transactionInfo = response.data.payload;
        
        if (response.data.status === "Success") {
          this.checkRedirectURL(1);
      
          if (
            this.transactionInfo.paymentResponse.teamEmployee?.qrCode == null
          ) {
            this.transactionInfo.paymentResponse.teamEmployee = {
              qrCode: this.transactionInfo.payment.qrCode,
            };
          }

          const groupQr = await this.$axios.get(
            `/api/v1/qrcodes/${this.transactionInfo.payment.qrCode}/group-code`
          );

          if (groupQr.data) {
            this.groupQrCode = groupQr.data;
          }

          const qrCode = await this.$axios.get(
            "/api/v1/qrcodes/" + this.transactionInfo.payment.qrCode
          );

          if (qrCode.data && qrCode.data.businessEntity) {
            this.qrCode = qrCode.data;
          }

          if (
            this.qrCode.team != null &&
            this.qrCode.businessEntity?.groupQrCode > 0 &&
            this.qrCode.team.qrCode !== this.qrCode.businessEntity?.groupQrCode
          ) {
            this.teamMode = true;
            this.transactionInfo.paymentResponse.teamEmployee = {
              name: qrCode.data.team.name,
              surName: "",
              qrCode: qrCode.data.team.qrCode,
              photoUrl: qrCode.data.businessEntity.logo,
            };
          }
        } else {
          this.paymentFailed = true;
          this.checkRedirectURL();
          // this.$message.warning(response.data.status);
        }
        this.fullScreenLoading = false;
      })
      .catch(() => {
        this.checkRedirectURL();
        this.fullScreenLoading = false;
      });
  },
  methods: {
    checkRedirectURL(term = 0) {
      const queryString = this.$cookie.get("query-string");
      let returnUrl = "";
      const params = [];

      if (queryString) {
        queryString.split("&").forEach((el) => {
          const [param, value] = el.split("=");

          if (param.toLowerCase() === "returnurl") {
            returnUrl = decodeURIComponent(value);
          } else {
            if (param === "utm_term") {
              params.push(`utm_term=${term}`);
            } else {
              params.push(el);
            }
          }
        });

        if (returnUrl) {
          setTimeout(() => {
            window.location = `${returnUrl}${params.join("&")}`;
          }, 5000);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.receipt-page {
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 40px;

  .receipt-company-name {
    text-align: center;
    font-size: 28px;
    color: #000;
    font-weight: bold;
    margin: 20px 0;
  }

  .body {
    &-title {
      margin: 32px 0 0 9px;

      h2 {
        color: #2d2e2f;
        font-size: 20px;
        line-height: 20px;
        font-family: "Raleway Bold", serif;
      }
    }

    &-buttons {
      padding: 0 12px;

      &-divider {
        height: 1.5px;
        background-color: #e3e5e5;
        margin: 30px 0;
      }
    }

    .primary-button {
      height: 48px;
      font-weight: bold;
    }
  }
}
</style>
